import { Component } from '@angular/core';

@Component({
  selector: 'app-x-common-toolbar-item',
  standalone: true,
  templateUrl: './x-common-toolbar-item.component.html',
  styleUrl: './x-common-toolbar-item.component.less',
})
export class XCommonToolbarItemComponent { }
